const types = {
    FETCH_WISH_LIST_SUCCESS: 'FETCH_WISH_LIST_SUCCESS',
    TOGGLE_WISH_LIST: 'TOGGLE_WISH_LIST',
};

export default types;